import { useEffect, useState } from 'react'
import { useActiveOrganization } from './use-organization'
import { NotificationSettings } from 'api/model'
import { notificationsListSettings } from 'api/notifications_endpoints/notificationsFromFileSpecWithTransformer'

function useFetchNotificationsListSettings(id: string) {
  const [activeOrganization] = useActiveOrganization()
  const [notificationSettings, setNotificationSettings] = useState<NotificationSettings | null>(null)

  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    async function fetchData() {
      if (!id) {
        return
      }

      setIsLoading(true)

      try {
        const response = await notificationsListSettings({ id })
        setNotificationSettings(response.data ? response.data : null)
      } catch (error) {
        setError(`${error}`)
      } finally {
        setIsLoading(false)
      }
    }

    fetchData()
  }, [activeOrganization, id])

  return {
    isLoading,
    notificationSettings,
    error,
  }
}

export { useFetchNotificationsListSettings }
